import type { Edge, ReactFlowInstance } from "@xyflow/react";

import type { Node } from "src/constants/NodeDataTypes";

declare global {
  interface Window {
    reactFlowInstance?: ReactFlowInstance<Node, Edge>;
  }
}

export const isRunningInCypressRun = () => {
  return Boolean("Cypress" in window && window.Cypress);
};

/**
 * Handle for e2e tests to drive the graph viewport, e.g. `fitView()` to bring a
 * node back inside the canvas. The zoom control is not a reliable route to it:
 * the side panes cover the control itself in a lot of the states tests get the
 * app into.
 */
export const exposeReactFlowInstanceToTests = (
  instance: ReactFlowInstance<Node, Edge>,
) => {
  if (isRunningInCypressRun()) {
    window.reactFlowInstance = instance;
  }
};
